export default {
  zh: {
    totalConisText: 'Total Coins',
    goldTip: '- You friend will receive a gift by using this code when finished register.',
    initCodeText: 'Gift Code',
    applyText: 'Share with Friends',
    listTitle: 'Invited Users',
    link: 'Come join me at App. ',
    copylinkText: 'Copy Link',
    whatappText: 'WhatsApp',
    goldTopTip: '- The invite will be completed when your freind use this gift code.'
  },
  en: {
    totalConisText: 'Total Coins',
    goldTip: '- You friend will receive a gift by using this code when finished register.',
    initCodeText: 'Gift Code',
    applyText: 'Share with Friends',
    listTitle: 'Invited Users',
    link: 'Come join me at App. ',
    copylinkText: 'Copy Link',
    whatappText: 'WhatsApp',
    goldTopTip: '- The invite will be completed when your freind use this gift code.'
  },
  ar: {
    // 阿拉伯
    totalConisText: 'اجمالي الكوينزات',
    goldTip: '- تكتمل الدعوة عندما يستخدم صديقك كود الهدية اثناء تسجيل الحساب.',
    initCodeText: 'كود الهدية',
    applyText: 'مشاركة مع صديق',
    listTitle: 'دعوة صديق',
    link: 'تعال وانضم لي',
    copylinkText: 'انسخ الرابط',
    whatappText: 'واتساب',
    goldTopTip: '- سيحصل صديقك على هدية عند استخدامه هذا الكود اثناء التسجيل.'
  },
  tr: {
    //土耳其
    totalConisText: 'Toplam Coins',
    goldTip: '- Arkadaşınız kayıt işlemi tamamlandığında bu kodu kullanarak bir hediye alacaktır.',
    initCodeText: 'Davet Kodu',
    applyText: 'Arkadaşlarınla ​​Paylaş',
    listTitle: 'Davet Edilen Kullanıcılar',
    link: 'Come join me at App. ',
    copylinkText: 'Link Kopyala',
    whatappText: 'WhatsApp',
    goldTopTip: '- Arkadaşınız bu hediye kodunu kullandığında davet tamamlanır.'
  },
  pt: {
    totalConisText: 'Moedas totais',
    goldTip: '- Seu amigo receberá um presente ao usar este código quando terminar o registro.',
    initCodeText: 'Código do presente',
    applyText: 'Compartilhar com amigos',
    listTitle: 'Usuários convidados',
    link: 'Venha se juntar a mim no App.',
    copylinkText: 'Copiar link',
    whatappText: 'WhatsApp',
    goldTopTip: '- O convite será concluído quando seu amigo usar este código de presente.'
  },
  id: {
    totalConisText: 'Total Koin',
    goldTip: '- Teman Anda akan menerima hadiah dengan menggunakan kode ini setelah selesai mendaftar.',
    initCodeText: 'Kode Hadiah',
    applyText: 'Bagikan dengan Teman',
    listTitle: 'Pengguna yang Diundang',
    link: 'Ayo bergabung dengan saya di App.',
    copylinkText: 'Salin Link',
    whatappText: 'WhatsApp',
    goldTopTip: '- Undangan akan selesai ketika teman Anda menggunakan kode hadiah ini.'
  },
  uz: {
    totalConisText: 'Jami tangalar',
    goldTip: "- Do'stingiz ushbu kodni ro'yxatdan o'tgach, sovg'a oladi.",
    initCodeText: "Sovg'a kodi",
    applyText: "Do'stlar bilan ulashish",
    listTitle: 'Taklif qilingan foydalanuvchilar',
    link: "Menga App-da qo'shiling.",
    copylinkText: 'Havolani nusxalash',
    whatappText: 'WhatsApp',
    goldTopTip: "- Taklif, do'stingiz ushbu sovg'a kodini ishlatganda tugaydi."
  },
  ru: {
    totalConisText: 'Общие монеты',
    goldTip: '- Ваш друг получит подарок, используя этот код после завершения регистрации.',
    initCodeText: 'Подарочный код',
    applyText: 'Поделиться с друзьями',
    listTitle: 'Приглашенные пользователи',
    link: 'Присоединяйтесь ко мне в приложении.',
    copylinkText: 'Скопировать ссылку',
    whatappText: 'WhatsApp',
    goldTopTip: '- Приглашение будет завершено, когда ваш друг использует этот подарочный код.'
  },
  fa: {
    totalConisText: 'تعداد کل سکه‌ها',
    goldTip: '- دوست شما با استفاده از این کد پس از اتمام ثبت‌نام، یک هدیه دریافت خواهد کرد.',
    initCodeText: 'کد هدیه',
    applyText: 'با دوستان به اشتراک بگذارید',
    listTitle: 'کاربران دعوت شده',
    link: 'به من در اپلیکیشن بپیوندید.',
    copylinkText: 'کپی لینک',
    whatappText: 'WhatsApp',
    goldTopTip: '- دعوت زمانی تکمیل می‌شود که دوست شما از این کد هدیه استفاده کند.'
  },
  ur: {
    totalConisText: 'کل سکے',
    goldTip: '- آپ کا دوست رجسٹریشن مکمل کرنے پر اس کوڈ کا استعمال کرکے تحفہ وصول کرے گا۔',
    initCodeText: 'تحفہ کوڈ',
    applyText: 'دوستوں کے ساتھ شیئر کریں',
    listTitle: 'مدعو کیے گئے صارفین',
    link: 'ایپ پر میرے ساتھ شامل ہوں۔',
    copylinkText: 'لنک کاپی کریں',
    whatappText: 'واٹس ایپ',
    goldTopTip: '- دعوت اس وقت مکمل ہوگی جب آپ کا دوست اس تحفہ کوڈ کا استعمال کرے گا۔'
  }
}



// WEBPACK FOOTER //
// src/pages/app/newInvitation/lang.js